// Menu Marketing — telas próprias: "Desempenho" (comparação de canais),
// "Conexões" (um lugar só para plugar canais — nada de análise misturada)
// e "Google Ads" (insights via Zernio, mesma pegada do painel Meta).
// Admin-only, como os demais relatórios comerciais.
import { frontendURL } from '../../../helper/URLHelper';

const MarketingPerformance = () => import('./MarketingPerformance.vue');
const MarketingConnections = () => import('./MarketingConnections.vue');
const GoogleAdsDashboard = () => import('./GoogleAdsDashboard.vue');
const MarketingPagesIndex = () => import('./MarketingPagesIndex.vue');
const MarketingPageBuilder = () => import('./pages/MarketingPageBuilder.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/marketing/desempenho'),
    name: 'marketing_performance',
    meta: {
      permissions: ['administrator'],
    },
    component: MarketingPerformance,
  },
  {
    path: frontendURL('accounts/:accountId/marketing/conexoes'),
    name: 'marketing_connections',
    meta: {
      permissions: ['administrator'],
    },
    component: MarketingConnections,
  },
  // ChatSuite Pages: landing pages geradas por IA (módulo próprio, R$97).
  {
    path: frontendURL('accounts/:accountId/marketing/paginas'),
    name: 'marketing_pages',
    meta: {
      permissions: ['administrator'],
    },
    component: MarketingPagesIndex,
  },
  {
    path: frontendURL('accounts/:accountId/marketing/paginas/:pageId/editor'),
    name: 'marketing_page_builder',
    meta: {
      permissions: ['administrator'],
    },
    component: MarketingPageBuilder,
  },
  {
    path: frontendURL('accounts/:accountId/marketing/google-ads'),
    name: 'marketing_google_ads',
    meta: {
      permissions: ['administrator'],
    },
    component: GoogleAdsDashboard,
  },
];
